// Import and register all your controllers from the importmap under controllers/*

import { application } from "./application"

// Import all controllers
import MobileMenuController from "./mobile_menu_controller"
import HeaderController from "./header_controller"
import LocaleController from "./locale_controller"
import ThemeController from "./theme_controller"
import FilterFormController from "./filter_form_controller"
import TableController from "./table_controller"
import ClearFiltersController from "./clear_filters_controller"
import TomSelectController from "./tom_select_controller"
import ProductGalleryController from "./product_gallery_controller"
import FormController from "./form_controller"
import SpecificationsFormController from "./specifications_form_controller"
import ImageUploadController from "./image_upload_controller"
import ImageLoaderController from "./image_loader_controller"
import ClickableRowController from "./clickable_row_controller"
import NotificationController from "./notification_controller"
import MobileFiltersController from "./mobile_filters_controller"
import ProductStepperController from "./product_stepper_controller"
import ProductAccordionController from "./product_accordion_controller"
import SortFormController from "./sort_form_controller"
import DebouncedSearchController from "./debounced_search_controller"
import TurboMorphController from "./turbo_morph_controller"
import Clipboard from '@stimulus-components/clipboard'
import CookieConsentController from "./cookie_consent_controller"
import InvoiceFormController from "./invoice_form_controller"
import InvoiceItemController from "./invoice_item_controller"
import InvoiceNotesController from "./invoice_notes_controller"

// Register all controllers manually
application.register("mobile-menu", MobileMenuController)
application.register("header", HeaderController)
application.register("locale", LocaleController)
application.register("theme", ThemeController)
application.register("filter-form", FilterFormController)
application.register("table", TableController)
application.register("clear-filters", ClearFiltersController)
application.register("tom-select", TomSelectController)
application.register("product-gallery", ProductGalleryController)
application.register("form", FormController)
application.register("specifications-form", SpecificationsFormController)
application.register("image-upload", ImageUploadController)
application.register("image-loader", ImageLoaderController)
application.register("clickable-row", ClickableRowController)
application.register("notification", NotificationController)
application.register("mobile-filters", MobileFiltersController)
application.register("product-stepper", ProductStepperController)
application.register("product-accordion", ProductAccordionController)
application.register("sort-form", SortFormController)
application.register("debounced-search", DebouncedSearchController)
application.register("turbo-morph", TurboMorphController)
application.register("clipboard", Clipboard)
application.register("cookie-consent", CookieConsentController)
application.register("invoice-form", InvoiceFormController)
application.register("invoice-item", InvoiceItemController)
application.register("invoice-notes", InvoiceNotesController)
